import { takeEvery } from 'redux-saga/effects'
import { putPromise } from '../../../helpers/redux'
import * as actions from './actions'
import { listAutomations } from './actions'

export function* refreshAutomationsAfterMutation() {
  yield takeEvery(
    [
      actions.CREATE_AUTOMATION_SUCCESS,
      actions.UPDATE_AUTOMATION_SUCCESS,
      actions.DELETE_AUTOMATION_SUCCESS,
    ],
    function* () {
      yield putPromise(listAutomations())
    },
  )
}
